module.exports = __webpack_public_path__ + "img/frasco_cili_500.9d31bf32.png";